'use strict';

define('$console', function () {
  'use strict';

  return window.console;
});
//# sourceMappingURL=console.js.map
